import SidebarLayout from '../../components/SidebarLayout';
import React, { useState, useEffect, useContext } from 'react';
import AuthContext from '../../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import Table from '../../components/MtssManagement/Table';
import AccessWrapper from '../../components/AccessWrapper';

export default function Subjects() {
  let { authTokens, user, postPageView, baseUrl } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  /* state variables to hold json data from the back-end */
  let [subjects, setSubjects] = useState([]);

  useEffect(() => {
    getSubjects();
    postPageView(baseUrl, user.name, user.role, 'mtss-management-subjects');
  }, []);

  let getSubjects = async () => {
    setLoading(true);
    let response = await fetch(`${baseUrl}/mtss/subjects/manage_list/`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + String(authTokens.access),
      },
    });
    let data = await response.json();

    if (response.status === 200) {
      setSubjects(data);
      setLoading(false);
    } else if (response.status === 403) {
      setLoading(false);
      navigate('/unauthorized');
    }
  };

  return (
    <AccessWrapper allowedGroups={['mtss_admin']}>
      <div>
        <SidebarLayout
          propComponents={
            <div className='bp-12 sm:pb-16 lg:pb-20'>
              <Table
                loading={loading}
                data={subjects}
                path={'/mtss/subject-update/'}
                dotSelector={'subject_name'}
                createNewLink={'/mtss/add-subject'}
              />
            </div>
          }
          heading={'Subjects'}
        />
      </div>
    </AccessWrapper>
  );
}
